import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'

import { APP_SHELL_PAGE_TITLE_SUBTITLE_GAP_PX } from '@/shared/layout/appShellPageLayout'

type Props = Readonly<{
  title: string
  description?: string
  badge?: ReactNode
}>

export function SensemakerPageTitle({ title, description, badge }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: `${APP_SHELL_PAGE_TITLE_SUBTITLE_GAP_PX}px` }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        <Typography
          component="h1"
          sx={{
            fontWeight: 700,
            fontSize: '24px',
            lineHeight: '32px',
            color: '#23262f',
            letterSpacing: '0.0703px',
          }}
        >
          {title}
        </Typography>
        {badge}
      </Box>
      {description ? (
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            color: '#4a5565',
            letterSpacing: '-0.1504px',
          }}
        >
          {description}
        </Typography>
      ) : null}
    </Box>
  )
}
